import { errors } from './assets/errors';
import { titles } from './assets/titles';
import { PaymentErrorInfo } from './errors';

/**
 * Payment errors that can be displayed to the user.
 * See more codes here: https://docs.stripe.com/declines/codes
 */
export const cardError: Map<string, PaymentErrorInfo> = new Map([
  [
    'authentication_required',
    {
      title: titles.SOMETHING_WENT_WRONG,
      description: errors.CARD_GENERIC_ERROR,
    },
  ],
  [
    'approve_with_id',
    {
      title: titles.SOMETHING_WENT_WRONG,
      description: errors.CARD_GENERIC_ERROR,
    },
  ],
  [
    'call_issuer',
    {
      title: titles.SOMETHING_WENT_WRONG,
      description: errors.CARD_GENERIC_DECLINE,
    },
  ],
  [
    'card_not_supported',
    {
      title: titles.CARD_NOT_SUPPORTED,
      description: errors.CARD_NOT_SUPPORTED,
      supportUrl: '/help/subscription/payment-method',
    },
  ],
  [
    'card_velocity_exceeded',
    {
      title: titles.CARD_TRY_AGAIN_LATER,
      description: errors.CARD_TRY_AGAIN_LATER,
    },
  ],
  [
    'currency_not_supported',
    {
      title: titles.CARD_NOT_SUPPORTED,
      description: errors.CARD_NOT_SUPPORTED,
      supportUrl: '/help/subscription/payment-method',
    },
  ],
  [
    'do_not_honor',
    {
      title: titles.CARD_DO_NOT_HONOR,
      description: errors.CARD_DO_NOT_HONOR,
    },
  ],
  [
    'do_not_try_again',
    {
      title: titles.SOMETHING_WENT_WRONG,
      description: errors.CARD_CANNOT_BE_USED,
    },
  ],
  [
    'duplicate_transaction',
    {
      title: titles.DUPLICATE_TRANSACTION,
      description: errors.DUPLICATE_TRANSACTION,
    },
  ],
  [
    'expired_card',
    { title: titles.CARD_EXPIRED, description: errors.CARD_EXPIRED },
  ],
  [
    'fraudulent',
    {
      title: titles.CARD_CANNOT_BE_USED,
      description: errors.CARD_BLOCKED_BY_KITTL,
    },
  ],
  [
    'generic_decline',
    {
      title: titles.SOMETHING_WENT_WRONG,
      description: errors.CARD_GENERIC_DECLINE,
      supportUrl: '/help/subscription/payment-method',
    },
  ],
  [
    'incorrect_number',
    {
      title: titles.CARD_INVALID_NUMBER,
      description: errors.CARD_INVALID_NUMBER,
    },
  ],
  [
    'incorrect_cvc',
    {
      title: titles.CARD_INVALID_CVC,
      description: errors.CARD_INVALID_SECURITY_CODE,
      supportUrl: '/help/subscription/failed-payments',
    },
  ],
  [
    'incorrect_pin',
    {
      title: titles.CARD_INVALID_PIN,
      description: errors.CARD_INVALID_PIN,
      supportUrl: '/help/subscription/failed-payments',
    },
  ],
  [
    'incorrect_zip',
    {
      title: titles.POSTAL_CODE_INVALID,
      description: errors.POSTAL_CODE_INVALID,
      supportUrl: '/help/subscription/failed-payments',
    },
  ],
  [
    'insufficient_funds',
    {
      title: titles.CARD_NOT_ENOUGH_LIMIT,
      description: errors.CARD_NOT_ENOUGH_LIMIT,
    },
  ],
  [
    'invalid_account',
    {
      title: titles.SOMETHING_WENT_WRONG,
      description: errors.CARD_GENERIC_DECLINE,
    },
  ],
  [
    'invalid_amount',
    {
      title: titles.SOMETHING_WENT_WRONG,
      description: errors.CARD_GENERIC_DECLINE,
    },
  ],
  [
    'invalid_cvc',
    {
      title: titles.CARD_INVALID_SECURITY_CODE,
      description: errors.CARD_INVALID_SECURITY_CODE,
    },
  ],
  [
    'invalid_expiry_month',
    {
      title: titles.CARD_INVALID_MONTH,
      description: errors.CARD_INVALID_EXPIRATION_MONTH,
      supportUrl: '/help/subscription/failed-payments',
    },
  ],
  [
    'invalid_expiry_year',
    {
      title: titles.CARD_INVALID_YEAR,
      description: errors.CARD_INVALID_EXPIRATION_YEAR,
      supportUrl: '/help/subscription/failed-payments',
    },
  ],
  [
    'invalid_number',
    {
      title: titles.CARD_INVALID_NUMBER,
      description: errors.CARD_INVALID_NUMBER,
      supportUrl: '/help/subscription/failed-payments',
    },
  ],
  [
    'invalid_pin',
    {
      title: titles.CARD_INVALID_PIN,
      description: errors.CARD_INVALID_PIN,
      supportUrl: '/help/subscription/failed-payments',
    },
  ],
  [
    'issuer_not_available',
    {
      title: titles.SOMETHING_WENT_WRONG,
      description: errors.CARD_ISSUER_NOT_AVAILABLE,
    },
  ],
  [
    'lost_card',
    {
      title: titles.CARD_CANNOT_BE_USED,
      description: errors.CARD_CANNOT_BE_USED,
    },
  ],
  [
    'merchant_blacklist',
    {
      title: titles.CARD_CANNOT_BE_USED,
      description: errors.CARD_BLOCKED_BY_KITTL,
    },
  ],
  [
    'new_account_information_available',
    {
      title: titles.SOMETHING_WENT_WRONG,
      description: errors.CARD_GENERIC_DECLINE,
      supportUrl: '/help/subscription/failed-payments',
    },
  ],
  [
    'no_action_taken',
    {
      title: titles.SOMETHING_WENT_WRONG,
      description: errors.CARD_GENERIC_DECLINE,
    },
  ],
  [
    'not_permitted',
    {
      title: titles.SOMETHING_WENT_WRONG,
      description: errors.CARD_GENERIC_DECLINE,
    },
  ],
  [
    'offline_pin_required',
    {
      title: titles.SOMETHING_WENT_WRONG,
      description: errors.CARD_INTERNAL_ERROR,
      supportUrl: '/help/subscription/failed-payments',
    },
  ],
  [
    'online_or_offline_pin_required',
    {
      title: titles.SOMETHING_WENT_WRONG,
      description: errors.CARD_INTERNAL_ERROR,
      supportUrl: '/help/subscription/failed-payments',
    },
  ],
  [
    'pickup_card',
    {
      title: titles.CARD_CANNOT_BE_USED,
      description: errors.CARD_CANNOT_BE_USED,
    },
  ],
  [
    'pin_try_exceeded',
    {
      title: titles.CARD_PIN_TRIES_EXCEEDED,
      description: errors.CARD_PIN_TRIES_EXCEEDED,
    },
  ],
  [
    'processing_error',
    {
      title: titles.SOMETHING_WENT_WRONG,
      description: errors.CARD_TRY_AGAIN,
      supportUrl: '/help/subscription/failed-payments',
    },
  ],
  [
    'reenter_transaction',
    {
      title: titles.SOMETHING_WENT_WRONG,
      description: errors.CARD_TRY_AGAIN,
      supportUrl: '/help/subscription/failed-payments',
    },
  ],
  [
    'restricted_card',
    {
      title: titles.CARD_CANNOT_BE_USED,
      description: errors.CARD_CANNOT_BE_USED,
    },
  ],
  [
    'revocation_of_all_authorizations',
    {
      title: titles.CARD_CANNOT_BE_USED,
      description: errors.CARD_CANNOT_BE_USED,
    },
  ],
  [
    'revocation_of_authorization',
    {
      title: titles.CARD_CANNOT_BE_USED,
      description: errors.CARD_CANNOT_BE_USED,
    },
  ],
  [
    'security_violation',
    {
      title: titles.CARD_CANNOT_BE_USED,
      description: errors.CARD_CANNOT_BE_USED,
    },
  ],
  [
    'service_not_allowed',
    {
      title: titles.CARD_CANNOT_BE_USED,
      description: errors.CARD_CANNOT_BE_USED,
    },
  ],
  [
    'stolen_card',
    {
      title: titles.CARD_CANNOT_BE_USED,
      description: errors.CARD_CANNOT_BE_USED,
    },
  ],
  [
    'stop_payment_order',
    {
      title: titles.CARD_CANNOT_BE_USED,
      description: errors.CARD_CANNOT_BE_USED,
    },
  ],
  [
    'testmode_decline',
    {
      title: titles.CARD_CANNOT_BE_USED,
      description: errors.CARD_CANNOT_BE_USED,
    },
  ],
  [
    'transaction_not_allowed',
    {
      title: titles.CARD_CANNOT_BE_USED,
      description: errors.CARD_CANNOT_BE_USED,
    },
  ],
  [
    'try_again_later',
    {
      title: titles.CARD_TRY_AGAIN_LATER,
      description: errors.CARD_TRY_AGAIN_LATER,
    },
  ],
  [
    'withdrawal_count_limit_exceeded',
    {
      title: titles.CARD_NOT_ENOUGH_LIMIT,
      description: errors.CARD_NOT_ENOUGH_LIMIT,
    },
  ],
]);
